import {
  createContext,
  type SetStateAction,
  type Dispatch,
  type Context,
} from 'react';

/** @internal */
export interface SelectedOverCalendarContextProps {
  /** Indicates whether the value was selected via the Calendar. */
  selectedOverCalendar?: boolean;
  /** Function to set the flag indicating the value was selected via the Calendar. */
  setSelectedOverCalendar?: Dispatch<SetStateAction<boolean | undefined>>;
  /** Indicates whether the Calendar's onChange event has been triggered. */
  calendarOnChangeFlag?: boolean;
  /** Function to set the flag indicating the Calendar's onChange event has been triggered. */
  setCalendarOnChangeFlag?: Dispatch<SetStateAction<boolean | undefined>>;
}

/**
 * TimeframeSelector and TimeRangePicker Context, used to access the selectedOverCalender in other components.
 * @internal
 */
export const SelectedOverCalendarContext: Context<SelectedOverCalendarContextProps> =
  createContext<SelectedOverCalendarContextProps>({
    selectedOverCalendar: undefined,
    setSelectedOverCalendar: undefined,
    calendarOnChangeFlag: undefined,
    setCalendarOnChangeFlag: undefined,
  });
